import { Col, Row } from 'antd';
import { TeamOutput, useFindGroupQuery } from 'gql/types';
import { Spin } from 'modules/common/components';
import TeamCollapse from 'modules/donor/components/TeamCollapse';
import { TeamsCardListSorter } from 'modules/donor/components/TeamsCardList/TeamsCardListSorter';
import { useTeamsSort } from 'modules/donor/hooks/useTeamsSort';
import { FC, useState } from 'react';
import { useParams } from 'react-router-dom';

export const TeamsCardList: FC = () => {
  const [currentEdit, setCurrentEdit] = useState<string | null>(null);
  const params = useParams();
  const groupId = params.id || '';
  const { data: groupData, loading: findGroupLoading } = useFindGroupQuery({
    variables: {
      input: {
        id: groupId,
      },
    },
  });
  const teams = (groupData?.findGroup.teams as TeamOutput[]) || [];
  const { sort, sortedTeams } = useTeamsSort(teams);

  return (
    <Spin spinning={findGroupLoading}>
      <Row gutter={[0, 15]}>
        <Col>
          <TeamsCardListSorter sorting={sort} />
        </Col>
        <Col span={24}>
          {sortedTeams.map((team) => (
            <TeamCollapse
              key={team.id}
              team={team}
              setCurrentEdit={setCurrentEdit}
              currentEdit={currentEdit}
            />
          ))}
        </Col>
      </Row>
    </Spin>
  );
};
